import { MapfreLinkComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-link/mapfre-link.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

import { UserService } from '../../../../_services/user.service';
import { ClientCredentialsService } from '../../../../_services/client-credentials/client-credentials.service';
import { ClientCredentialsTokenService } from '../../../../_services/client-credentials/client-credentials-token.service';
import { ValidateEmailService } from '../../../../_services/signup-process-service/validate-email.service';
import { AcmicService, AlertService } from '@mapfre-design-library/src/public_api';
import { Router, ActivatedRoute , RouterModule } from '@angular/router';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLinkComponent],
  selector: 'app-commercial-validate-email',
  templateUrl: './commercial-validate-email.component.html',
})
export class CommercialValidateEmailComponent implements OnInit {
  email: any;
  user_detail: any = [];
  isAcmic:boolean;

  constructor(
    private alertService: AlertService,
    private _userService: UserService,
    private validateEmailService: ValidateEmailService,
    private clientCredentialsTokenService: ClientCredentialsTokenService,
    private clientCredentialsService: ClientCredentialsService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService:AcmicService
  ) {}

  ngOnInit() {
    this.user_detail = this._userService.getUserInfoInStorage();
    this.isAcmic=this.acmicService.isACMIC();
    if (this.user_detail) {
      this.email = this.user_detail['userDetails']['email']['address'];
      localStorage.removeItem('createuserinfo');
    } else {
      this.activatedRoute.queryParams.subscribe((params) => {
        this.email = params['email'];
        if (!this.email) {
          this.router.navigate(['login']);
        }
      });
    }

    if (!this.clientCredentialsTokenService.getToken()) {
      this.clientCredentialsService.getToken().subscribe();
    }
  }

  sendEmail() {
    // Call sendValidationEmail for send Resent Verification mail form user email address
    this.validateEmailService.sendValidationEmail(this.email).subscribe(
      () => {
        this.alertService.success('VERIFICATION_EMAIL_SENT');
      },
      (error) => {
        this.errorRedirectionService.errorHandler(
          error,
          'VERIFICATION_EMAIL_ERROR'
        );
      }
    );
  }
}
